/* Creset theme — shared script: live catalog, Shopify cart, nav/footer, motion. */
const C = window.CRESET || { root: "/", products: [], links: {}, assets: {} };
const ROOT = C.root.endsWith("/") ? C.root : C.root + "/";
const SHIP_NOTE = "Coming soon";
const LINES = {
  cherry: "Cherry just got a massive upgrade.",
  lemon: "Not your traditional lemon water.",
  variety: "Cherry and lemon in one box.",
};

/* ——— catalog from Shopify (rendered into the page by layout/theme.liquid) ——— */
const PRODUCTS = {};
for (const sp of C.products) {
  // flavor comes from the product type, or from the title after "|" ("Creatine Water | Cherry")
  const name = (sp.type || sp.title.split("|").pop()).trim();
  const key = name.toLowerCase();
  if (PRODUCTS[key]) continue;
  const first = sp.images[0] || { src: "", alt: name, ratio: .66 };
  PRODUCTS[key] = {
    key, name, handle: sp.handle, url: sp.url,
    accent: key.includes("lemon") ? "var(--lemon)" : "var(--red)",
    wide: key === "variety" || first.ratio > .72,
    line: LINES[key] || "",
    pack: first.src,
    gallery: sp.images.map((im, i) => ({ src: im.src, alt: im.alt, kind: i === 0 ? "pack" : "photo" })),
    variants: sp.variants.map(v => ({ title: v.title, id: String(v.id), price: v.price / 100, count: parseInt(v.title, 10) || 1, available: v.available })),
  };
}
const ORDER = [...["cherry", "lemon", "variety"].filter(k => PRODUCTS[k]), ...Object.keys(PRODUCTS).filter(k => !["cherry", "lemon", "variety"].includes(k))];
const byHandle = h => Object.values(PRODUCTS).find(p => p.handle === h);
const money = n => "$" + n.toFixed(2);

/* ——— Shopify AJAX cart ——— */
let cartState = { items: [], item_count: C.cartCount || 0, total_price: 0 };
const post = (url, body) => fetch(ROOT + url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) });
const Cart = {
  async refresh() { const r = await fetch(ROOT + "cart.js", { headers: { Accept: "application/json" } }); cartState = await r.json(); render(); },
  async add(id, qty = 1) {
    const r = await post("cart/add.js", { items: [{ id: Number(id), quantity: qty }] });
    if (!r.ok) { const e = await r.json().catch(() => ({})); alert(e.description || "Sorry, that couldn't be added to your cart."); return; }
    await this.refresh(); bump(); openCart();
  },
  async set(key, qty) { const r = await post("cart/change.js", { id: key, quantity: qty }); cartState = await r.json(); render(); },
};

/* ——— shared chrome ——— */
const page = document.body.dataset.page;
const L = C.links;
const navLinks = [[L.shop, "Shop", "shop"], [L.science, "Science", "science"], [L.about, "About", "about"]];

document.body.insertAdjacentHTML("afterbegin", `
<div class="grain" aria-hidden="true"></div>
<div class="glow" id="glow" aria-hidden="true"></div>
<nav class="nav" id="nav">
  <a class="mark" href="${L.home}" aria-label="Creset home"><svg viewBox="0 0 1400 764" aria-hidden="true"><filter id="navWhite" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="0 0 0 0 .08  0 0 0 0 .08  0 0 0 0 .07  -1 0 0 0 1" result="m"/><feComposite in="m" in2="SourceAlpha" operator="in"/></filter><image href="${C.assets.cr}" width="1400" height="764" filter="url(#navWhite)"/></svg></a>
  <ul class="links">${navLinks.map(([h, t, k]) => `<li><a href="${h}"${k === page ? ' aria-current="page"' : ""}>${t}</a></li>`).join("")}</ul>
  <div class="right">
    <button class="menu-btn" id="menuBtn" aria-label="Open menu">Menu</button>
    <button class="cart-btn" id="cartBtn" aria-label="Open cart">Cart <span class="n" id="cartCount">${cartState.item_count}</span></button>
  </div>
</nav>
<div class="mobile-menu" id="mobileMenu" role="dialog" aria-label="Menu">
  <button class="close" id="menuClose">Close</button>
  <a href="${L.home}">Home</a>${navLinks.map(([h, t]) => `<a href="${h}">${t}</a>`).join("")}
</div>
<div class="scrim" id="scrim"></div>
<aside class="drawer" id="drawer" aria-label="Cart" aria-hidden="true">
  <header><h2>Cart</h2><button class="x" id="cartClose">Close</button></header>
  <div class="items" id="cartItems"></div>
  <footer id="cartFoot">
    <div class="sub"><span class="label">Subtotal</span><strong id="cartTotal">$0.00</strong></div>
    <a class="btn solid" id="checkout" href="${ROOT}checkout">Checkout <span class="arr">→</span></a>
    <span class="label note">${SHIP_NOTE}<br>Shipping &amp; taxes calculated at checkout</span>
  </footer>
</aside>`);

document.body.insertAdjacentHTML("beforeend", `
<footer class="site">
  <div class="foot-cta">
    <h2 class="display reveal">The first<br>ready-to-drink<br>creatine<span>.</span></h2>
    <a class="btn reveal d1" href="${L.shop}">Shop Creset <span class="arr">→</span></a>
  </div>
  <div class="foot-grid">
    <div><img class="wordmark" src="${C.assets.wordmark}" alt="creset."><p class="label">Ready-to-drink<br>creatine water.</p></div>
    <div><h4 class="label">Shop</h4><ul>${ORDER.map(k => `<li><a href="${PRODUCTS[k].url}">${PRODUCTS[k].name}</a></li>`).join("")}<li><a href="${L.shop}">Shop all</a></li></ul></div>
    <div><h4 class="label">Creset</h4><ul><li><a href="${L.science}">Science</a></li><li><a href="${L.about}">About</a></li><li><a href="${ROOT}policies/contact-information">Contact</a></li><li><a href="${L.account}">Account</a></li></ul></div>
    <div><h4 class="label">Legal</h4><ul><li><a href="${ROOT}policies/privacy-policy">Privacy</a></li><li><a href="${ROOT}policies/refund-policy">Refunds</a></li><li><a href="${ROOT}policies/terms-of-service">Terms</a></li></ul></div>
  </div>
  <div class="legal"><span class="label">© ${new Date().getFullYear()} Creset</span><span class="label">5g creatine · 0g sugar · electrolytes</span></div>
</footer>`);

/* ——— cart UI ——— */
const $ = id => document.getElementById(id);
function render() {
  const items = cartState.items || [];
  $("cartCount").textContent = cartState.item_count;
  $("cartTotal").textContent = money((cartState.total_price || 0) / 100);
  $("cartFoot").style.display = items.length ? "" : "none";
  $("cartItems").innerHTML = items.length ? items.map(i => {
    const p = byHandle(i.product_handle);
    const name = p ? p.name : i.product_title;
    const img = p ? p.pack : i.image;
    const per = parseInt(i.variant_title, 10);
    return `<div class="line-item">
      <a class="thumb" href="${i.url}"><img src="${img}" alt=""></a>
      <div><h3>${name}</h3><div class="label meta">${i.variant_title || ""}${per ? ` · ${per * i.quantity} bottles` : ""}</div>
        <div class="qty"><button data-k="${i.key}" data-q="${i.quantity - 1}" aria-label="Decrease">−</button><span>${i.quantity}</span><button data-k="${i.key}" data-q="${i.quantity + 1}" aria-label="Increase">+</button></div></div>
      <div class="end"><span class="price">${money(i.final_line_price / 100)}</span><button class="rm" data-k="${i.key}" data-q="0">Remove</button></div>
    </div>`;
  }).join("") : `<div class="empty"><span class="label">Your cart is empty</span><a class="btn" href="${L.shop}">Shop <span class="arr">→</span></a></div>`;
}
$("cartItems").addEventListener("click", e => {
  const b = e.target.closest("[data-k]");
  if (b) Cart.set(b.dataset.k, Math.max(0, +b.dataset.q));
});
function openCart() { $("drawer").classList.add("open"); $("scrim").classList.add("open"); $("drawer").setAttribute("aria-hidden", "false"); document.body.classList.add("lock"); }
function closeCart() { $("drawer").classList.remove("open"); $("scrim").classList.remove("open"); $("drawer").setAttribute("aria-hidden", "true"); document.body.classList.remove("lock"); }
function bump() { const n = $("cartCount"); n.classList.remove("bump"); void n.offsetWidth; n.classList.add("bump"); }
$("cartBtn").onclick = () => { openCart(); Cart.refresh(); };
$("cartClose").onclick = closeCart; $("scrim").onclick = closeCart;
$("menuBtn").onclick = () => $("mobileMenu").classList.add("open");
$("menuClose").onclick = () => $("mobileMenu").classList.remove("open");
addEventListener("keydown", e => { if (e.key === "Escape") { closeCart(); $("mobileMenu").classList.remove("open"); } });
render();
Cart.refresh().catch(() => {});

/* ——— product cards ——— */
function cardHTML(k, i = 0) {
  const p = PRODUCTS[k];
  return `<article class="card ${k}${p.wide ? " wide" : ""} reveal d${i}">
    <a class="stage" href="${p.url}"><span class="tag" style="--accent:${p.accent}">${p.name}</span><img src="${p.pack}" alt="${p.gallery[0] ? p.gallery[0].alt : p.name}"></a>
    <div class="info">
      <div class="row"><h3><small>Creatine Water</small>${p.name}</h3><span class="price">${money(p.variants[0].price)}</span></div>
      <p class="line">${p.line}</p>
      <div class="packs" data-i="0"><span class="pill"></span>${p.variants.map((v, j) => `<button aria-pressed="${j === 0}">${v.title}</button>`).join("")}</div>
      <div class="buy"><button class="btn solid add">Add to cart <span class="arr">+</span></button><a class="btn ghost" href="${p.url}" aria-label="View ${p.name}">View</a></div>
    </div>
  </article>`;
}
function wirePacks(root, p, onChange) {
  const packs = root.querySelector(".packs"); let idx = 0;
  packs.querySelectorAll("button").forEach((b, i) => b.addEventListener("click", () => {
    idx = i; packs.dataset.i = i;
    packs.querySelectorAll("button").forEach((x, j) => x.setAttribute("aria-pressed", j === i));
    onChange(p.variants[i]);
  }));
  return () => p.variants[idx];
}
document.querySelectorAll("[data-cards]").forEach(grid => {
  const want = grid.dataset.cards === "all" ? ORDER : grid.dataset.cards.split(",");
  const keys = want.filter(k => PRODUCTS[k] && k !== grid.dataset.except);
  grid.innerHTML = keys.map(cardHTML).join("");
  grid.querySelectorAll(".card").forEach((card, n) => {
    const p = PRODUCTS[keys[n]];
    const current = wirePacks(card, p, v => card.querySelector(".price").textContent = money(v.price));
    card.querySelector(".add").addEventListener("click", () => Cart.add(current().id));
  });
});

/* ——— motion ——— */
const io = new IntersectionObserver(es => es.forEach(e => {
  if (!e.isIntersecting) return;
  e.target.classList.add("in");
  e.target.querySelectorAll("[data-to]").forEach(num => {
    const to = +num.dataset.to, unit = num.querySelector("sup").outerHTML, t0 = performance.now();
    const tick = now => { const k = Math.min(1, (now - t0) / 1500); num.innerHTML = Math.round(to * (1 - Math.pow(1 - k, 4))) + unit; if (k < 1) requestAnimationFrame(tick); };
    requestAnimationFrame(tick);
  });
  io.unobserve(e.target);
}), { threshold: .12, rootMargin: "0px 0px -6% 0px" });
document.querySelectorAll(".reveal:not(.in)").forEach(el => io.observe(el));

const nav = $("nav");
const onScroll = () => nav.classList.toggle("solid", scrollY > 40);
addEventListener("scroll", onScroll, { passive: true }); onScroll();

const glow = $("glow");
let gx = innerWidth / 2, gy = innerHeight / 2, tx = gx, ty = gy;
addEventListener("pointermove", e => { tx = e.clientX; ty = e.clientY; });
(function loop() { gx += (tx - gx) * .08; gy += (ty - gy) * .08; glow.style.transform = `translate(${gx - glow.offsetWidth / 2}px,${gy - glow.offsetHeight / 2}px)`; requestAnimationFrame(loop); })();
